import type { FaireProductEntity } from "../../entity_types/product";

export const p_sdzwyj69r3: FaireProductEntity = {
  token: "p_sdzwyj69r3",
  type: "product",
  name: "Croissant Denim Baseball Cap/Dad Hat",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/469d25e0bec1485b7f9d61613dd1c72db9d492b29e8150aa02fe4f069cc0ece7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7bd07fd12a74150c72814aae0593074bf77232bf6f14601d9f965733f38998d.jpeg"
  ],
  priceDollars: 17.5,
  description: "Rise and shine in style with the Croissant Hat. Crafted for comfort and flair, this soft, adjustable hat features an embroidered croissant icon that foodies will adore. Whether you’re running errands, meeting friends for coffee (and a pastry), or just want a playful treat to brighten your day, this hat is a perfect accessory. \n\nMakes a great gift for bakers, brunch lovers, or anyone who loves food-inspired designs.\n\nGood to know:\n\n * Light denim hat with embroidered illustrated croissant design \n * Features adjustable back buckle \n * Designed in Kingston, NY by Mel Andrel ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:59.200Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
